import fetch from '@/plugin/axios'

// 获取动画列表
export function getAnimList (data) {
  return fetch({
    url: '/api/common/bot-anim/list',
    method: 'Post',
    data: data
  })
}

// 获取动画详情
export function getAnimDetail (id) {
  return fetch({
    url: `/api/common/bot-anim/info/${id}`,
    method: 'Get'
  })
}

// 新增动画
export function addAnim (data) {
  return fetch({
    url: '/api/common/bot-anim/add',
    method: 'Post',
    data: data
  })
}

// 修改动画
export function updateAnim (id, data) {
  return fetch({
    url: `/api/common/bot-anim/update/${id}`,
    method: 'Post',
    data: data
  })
}

// 删除动画
export function deleteAnim (id) {
  return fetch({
    url: `/api/common/bot-anim/${id}`,
    method: 'Delete'
  })
}
